import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSRptCompras (compras) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Compras",
        Subject: "Compras",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      data.push([
        // 'Fecha de Registro',
        'Fecha de Comprobante',
        'Proveedor',
        'Razón Social',
        'Condición Fiscal',
        'CUIT',
        'Comprobante',
        'Número',
        'Monto Gravado',
        // 'Monto Gravado (21%)',
        // 'Monto Gravado (10.5%)',
        // 'Monto Gravado (Otros)',
        'Monto Exento',
        'Monto No Gravado',
        'Monto Iva Insc.',
        'Monto Percep. Iva',
        'Monto Percep. Ganancias',
        'Monto Percep. C.I.',
        'Monto Percep. II.BB.',
        'Monto Otros Impuestos/Percepciones',
        'Monto Total',
      ]);

      if (compras.length != 0) {
        compras.forEach(compra => {
          data.push([
            // this.$options.filters.fecha(compra.fechaRegistro),
            this.$options.filters.fecha(compra.fechaComprobante),
            compra.proveedor,
            compra.razonSocial,
            compra.condicionFiscal,
            this.$options.filters.cuit(compra.cuit),
            compra.comprobanteTipo,
            compra.numeroCompleto,
            compra.montoGravado,
            // compra.montoGravado21,
            // compra.montoGravado105,
            // compra.montoGravadoOtros,
            compra.montoExento,
            compra.montoNoGravado,
            compra.montoIvaInscripto,
            compra.montoPercepcionIva,
            compra.montoPercepcionGanancias,
            compra.montoPercepcionComercioIndustria,
            compra.montoPercepcionesProvinciales,
            compra.montoOtrosImpuestos,
            compra.montoTotal
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "compras");
      XLSX.writeFile(wb, "compras.xlsx");

      return;
    },

    exportXLSRptPercepcionesCompras (percepciones) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Percepciones",
        Subject: "PercepcionesCompras",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      data.push([
        'Codigo Jurisdicción',
        'Jurisdicción',
        'Importe',
        'Fecha de Comprobante',
        'Proveedor',
        'CUIT',
        'Comprobante',
        'Número',
      ]);

      if (percepciones.length != 0) {
        percepciones.forEach(percepcion => {
          data.push([
            // this.$options.filters.fecha(compra.fechaRegistro),
            percepcion.jurisdiccionCodigo,
            percepcion.jurisdiccion,
            percepcion.importe,
            this.$options.filters.fecha(percepcion.fechaComprobante),
            percepcion.proveedor,
            this.$options.filters.cuit(percepcion.documentoNumero),
            percepcion.comprobante,
            percepcion.numero
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "percepciones-compras");
      XLSX.writeFile(wb, "percepciones-compras.xlsx");

      return;
    },

    exportXLSRptComprasFecha (compras) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Control de Compras",
        Subject: "Compras",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      data.push([
        'Fecha de Registro',
        'Fecha de Comprobante',
        'Proveedor',
        'Razón Social',
        'Condición Fiscal',
        'CUIT',
        'Comprobante',
        'Número',
        'Monto Gravado',
        // 'Monto Gravado (21%)',
        // 'Monto Gravado (10.5%)',
        // 'Monto Gravado (Otros)',
        'Monto Exento',
        'Monto No Gravado',
        'Monto Iva Insc.',
        'Monto Percep. Iva',
        'Monto Percep. Ganancias',
        'Monto Percep. C.I.',
        'Monto Percep. II.BB.',
        'Monto Otros Impuestos/Percepciones',
        'Monto Total',
      ]);

      if (compras.length != 0) {
        compras.forEach(compra => {
          data.push([
            this.$options.filters.fecha(compra.fechaRegistro),
            this.$options.filters.fecha(compra.fechaComprobante),
            compra.proveedor,
            compra.razonSocial,
            compra.condicionFiscal,
            this.$options.filters.cuit(compra.cuit),
            compra.comprobanteTipo,
            compra.numeroCompleto,
            compra.montoGravado,
            // compra.montoGravado21,
            // compra.montoGravado105,
            // compra.montoGravadoOtros,
            compra.montoExento,
            compra.montoNoGravado,
            compra.montoIvaInscripto,
            compra.montoPercepcionIva,
            compra.montoPercepcionGanancias,
            compra.montoPercepcionComercioIndustria,
            compra.montoPercepcionesProvinciales,
            compra.montoOtrosImpuestos,
            compra.montoTotal
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "compras");
      XLSX.writeFile(wb, "compras.xlsx");

      return;
    },
  }
}
